import {Field} from './field';

export class SummaryData {
   constructor({
      id = null,
      period,
      account = null,
      uploadFileId = null,
      vendor = null,
      vendorId = null,
      contractorId = null,
      employeeId = null,
      location = null,
      totalDebit = null,
      totalCredit = null,
      percentage = null,
      projectsData = null,
      activitiesData = null,
      assigneeId = null,
   }) {
      this.id = id;
      this.period = period;
      this.account = account;
      this.uploadFileId = uploadFileId;
      this.vendor = vendor;
      this.vendorId = vendorId;
      this.contractorId = contractorId;
      this.employeeId = employeeId;
      this.location = location;
      this.totalDebit = totalDebit;
      this.totalCredit = totalCredit;
      const amountValue = this.totalDebit;
      this.netAmount = new Field({
         value: amountValue !== null ? amountValue - totalCredit : null,
      });
      this.percentage = new Field({value: percentage});
      this.projectsData = projectsData;
      this.activitiesData = activitiesData;
      this.assigneeId = assigneeId;
   }

   get isAdHoc() {
      /** "Ad-Hoc" expense summaries are defined as those tied to an ad-hoc vendor, i.e. having a non-null vendorId value */
      return !!this.vendorId || !!this.contractorId || !!this.employeeId;
   }
}
